"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledFieldsetCustomBody = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const helpers_1 = require("../../../helpers");
exports.StyledFieldsetCustomBody = styled_components_1.default.tr `
    & td {
        padding-left: ${helpers_1.SPACING_S};
    }
`;
//# sourceMappingURL=FieldsetCustomBody.styles.js.map